import script from "./AIPopupComponent.vue?vue&type=script&setup=true&lang=tsx"
export * from "./AIPopupComponent.vue?vue&type=script&setup=true&lang=tsx"

import "./AIPopupComponent.vue?vue&type=style&index=0&id=7ba65b5d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ba65b5d"]])

export default __exports__